import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

/**
 * Create a new sub-admin by sending an invitation email
 * @param {string} adminId - The ID of the main admin
 * @param {string} email - Email address of the sub-admin to create
 * @param {string} token - Authentication token
 * @returns {Promise} API response
 */
export const createSubAdmin = async (adminId, email, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/admin/${adminId}/sub-admins`,
      { email },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || 
      'Failed to create sub-admin'
    );
  }
};

/**
 * Get all sub-admins for a main admin
 * @param {string} adminId - The ID of the main admin
 * @param {string} token - Authentication token
 * @returns {Promise} API response with sub-admins list
 */
export const getSubAdmins = async (adminId, token) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/admin/${adminId}/sub-admins`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || 
      'Failed to fetch sub-admins'
    );
  }
};

/**
 * Delete a sub-admin and revoke their access
 * @param {string} adminId - The ID of the main admin
 * @param {string} subAdminId - The ID of the sub-admin to delete
 * @param {string} token - Authentication token
 * @returns {Promise} API response
 */
export const deleteSubAdmin = async (adminId, subAdminId, token) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/admin/${adminId}/sub-admins/${subAdminId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || 
      'Failed to delete sub-admin'
    );
  }
};
